export const DEFAULT_API_URLS = {
  LOCAL: 'https://comercial.ap.signa.net.br/graphql',
  PRODUCTION: '/graphql',
  DEVELOPMENT: 'https://bluelogistica.ecargoasp.com.br/graphql'
}
